module.exports = __webpack_public_path__ + "static/img/u4.be6f29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kexie/regen/u4.png
// module id = BqV1
// module chunks = 0